import {
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  HStack,
  Icon
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import {
  chooseDataStateType,
  MaintenanceModalDispLabels
} from '../../../molecules/MaintenanceModalDispLabels';
import { MaintenanceFooter } from '../MaintenanceFooter';
import {
  ArrowUpDownIcon,
  TriangleDownIcon,
  TriangleUpIcon
} from '@chakra-ui/icons';
import { QueryTrainGroupsApi } from '../../../../apis/QueryMaintenance.api';
import { TrainGroupsSearchCondition } from '../../../../pages/TrainGroupsMaintenance';

export interface TrainGroupsType {
  id: number;
  name: string;
  low_floor_flg: boolean;
  created_at: string;
  updated_at: string;
}

interface props {
  TrainGroupsDatas: TrainGroupsType[] | undefined | null;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<TrainGroupsType[] | undefined | null>
  >;
  setChooseData: (data: chooseDataStateType) => void;
  onOpenBrowse: () => void;
  onOpenEdit: () => void;
  onToggle: () => void;
  Query: TrainGroupsSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<TrainGroupsSearchCondition>>;
  createOrUpdate: boolean;
  searchSwitch: boolean;
}
const headers = [
  { label: 'ID', key: 'id' },
  { label: '形式', key: 'name' },
  { label: '低床車両', key: 'low_floor_flg' },
  { label: '登録日時', key: 'created_at' },
  { label: '更新日時', key: 'updated_at' }
];

const TableColumnEnum = {
  id: 'id',
  name: 'name',
  low_floor_flg: 'low_floor_flg',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

const GetCsvFileName = () => {
  const date = new Date();
  const hour =
    date.getMonth().toString().length === 1
      ? '0' + (date.getMonth() + 1).toString()
      : date.getMonth().toString();
  const day =
    date.getDate().toString().length === 1
      ? '0' + date.getDate().toString()
      : date.getDate().toString();
  return 'train-groups-' + date.getFullYear() + '-' + hour + '-' + day;
};

export const MaintenanceTrainGroupsTable: React.FC<props> = (props) => {
  const {
    TrainGroupsDatas,
    setMaintenanceDatas,
    setChooseData,
    onOpenBrowse,
    onOpenEdit,
    onToggle,
    Query,
    setQuery,
    createOrUpdate,
    searchSwitch
  } = props;
  const [pageNow, setPageNow] = useState<number>(1);
  const [columnSortType, setColumnSortType] = useState<{
    key: string;
    sort: boolean;
  }>({ key: '', sort: false });
  const pageDispMax = 30;
  const pageMax = 6;
  const csvFileName = GetCsvFileName();
  const GetPageCount = (): number => {
    if (TrainGroupsDatas !== undefined && TrainGroupsDatas !== null) {
      const divisionCount = Math.floor(TrainGroupsDatas.length / pageDispMax);
      const remCount = TrainGroupsDatas.length % pageDispMax === 0 ? 0 : 1;
      return divisionCount + remCount;
    }
    return 1;
  };
  const ColumnNameTriangleType = (column: string) => {
    if (columnSortType.key === column) {
      if (columnSortType.sort) {
        return TriangleUpIcon;
      } else {
        return TriangleDownIcon;
      }
    }
    return ArrowUpDownIcon;
  };

  const ColumnSortApi = async (column: string) => {
    const params = new URLSearchParams();
    const sortType = !columnSortType.sort;
    params.append('order', column + (sortType ? '_asc' : '_desc'));

    Query.model !== '' && params.append('name_contains', Query.model);
    Query.dateCreatedFrom !== '' &&
      params.append('created_at_gte', Query.dateCreatedFrom);
    Query.dateCreatedTo !== '' &&
      params.append('created_at_lt', Query.dateCreatedTo);
    Query.dateUpdatedFrom !== '' &&
      params.append('updated_at_gte', Query.dateUpdatedFrom);
    Query.dateUpdatedTo !== '' &&
      params.append('updated_at_lt', Query.dateUpdatedTo);

    const query = '/?' + params.toString();

    setQuery((pre) => ({ ...pre, sort: { key: column, sortType: sortType } }));

    const response = await QueryTrainGroupsApi(query);
    if (response.success && response.data !== null) {
      setMaintenanceDatas(response.data);
      setColumnSortType({ key: column, sort: sortType });
    } else {
      alert(column + 'のソートに失敗しました。');
    }
  };

  useEffect(() => {
    setPageNow(1);
  }, [searchSwitch]);

  useEffect(() => {
    setPageNow(1);
    setColumnSortType({ key: '', sort: false });
  }, [createOrUpdate]);

  return (
    <>
      <TableContainer
        position='absolute'
        h='100%'
        w='100%'
        ml={5}
        overflowY='auto'
        gridRow='2/3'
        gridColumn='1/2'
        overflowX='unset'
      >
        <Table variant='simple'>
          <Thead borderWidth='1px' position='sticky' top={0} zIndex='docked'>
            <Tr bg='gray.800'>
              <Th
                cursor='pointer'
                textAlign='center'
                borderWidth='1px'
                color='white'
                onClick={() => ColumnSortApi(TableColumnEnum.id)}
              >
                <HStack>
                  <label style={{ cursor: 'pointer' }}>ID</label>
                  <Icon
                    ml={1}
                    as={ColumnNameTriangleType(TableColumnEnum.id)}
                  />
                </HStack>
              </Th>
              <Th
                cursor='pointer'
                textAlign='center'
                borderWidth='1px'
                color='white'
                onClick={() => ColumnSortApi(TableColumnEnum.name)}
              >
                <HStack>
                  <label style={{ cursor: 'pointer' }}>形式</label>
                  <Icon
                    ml={1}
                    as={ColumnNameTriangleType(TableColumnEnum.name)}
                  />
                </HStack>
              </Th>
              <Th textAlign='center' borderWidth='1px' color='white'>
                <HStack>
                  <label>低床車両</label>
                </HStack>
              </Th>
              <Th textAlign='center' borderWidth='1px' color='white'>
                <HStack>
                  <label>登録日時</label>
                </HStack>
              </Th>
              <Th textAlign='center' borderWidth='1px' color='white'>
                <HStack>
                  <label>更新日時</label>
                </HStack>
              </Th>
              <Th textAlign='center' borderWidth='1px' color='white'></Th>
            </Tr>
          </Thead>
          <Tbody>
            {TrainGroupsDatas !== undefined &&
              TrainGroupsDatas !== null &&
              TrainGroupsDatas.map((data, i) => {
                if (
                  pageDispMax * pageNow - pageDispMax <= i &&
                  i < pageDispMax * pageNow
                ) {
                  return (
                    <Tr key={`${'trainGroups_' + i}`}>
                      <Td>{data.id}</Td>
                      <Td>{data.name}</Td>
                      <Td>{data.low_floor_flg ? '◯' : '✕ '}</Td>
                      <Td>{data.created_at}</Td>
                      <Td>{data.updated_at}</Td>
                      <Td>
                        <MaintenanceModalDispLabels
                          data={{ type: 'trainGroups', trainGroups: data }}
                          setChooseData={setChooseData}
                          onOpenBrowse={onOpenBrowse}
                          onOpenEdit={onOpenEdit}
                          onToggle={onToggle}
                        />
                      </Td>
                    </Tr>
                  );
                }
              })}
          </Tbody>
        </Table>
      </TableContainer>
      <MaintenanceFooter
        CsvData={TrainGroupsDatas !== undefined ? TrainGroupsDatas : []}
        DataLength={TrainGroupsDatas?.length}
        Headers={headers}
        CsvFileName={csvFileName}
        GetPageCount={GetPageCount}
        pageMax={pageMax}
        pageNow={pageNow}
        setPageNow={setPageNow}
      />
    </>
  );
};
